// 两个标签,展示字数少的短歌名（banzou_vip、vip-collection页面短歌名字数单独控制）; 一个标签时,用长歌名
const musicNameF = (music_name, short, shortNumber = 5) => {
    const musicName_5 = music_name.length > shortNumber ? `${music_name.slice(0, shortNumber)}...` : music_name
    const musicName_7 = music_name.length > 8 ? `${music_name.slice(0, 7)}...` : music_name
    return short ? musicName_5 : musicName_7
}
// 金主名称字数限制
const goldNameF = (val) => (val?.length > 5 ? `${val.slice(0, 5)}...` : val)

// 分类歌单歌手名截取一个
const songSingerF = (val) => (val ? val.split(',')[0] : '')

export default {
    musicNameF,
    goldNameF,
    songSingerF,
}
